var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { RacingStore } from "../../data/store";
// external components
import * as CMP from "./components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingRegionSwitcher component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
var RacingRegionSwitcher = /** @class */ (function (_super) {
    __extends(RacingRegionSwitcher, _super);
    /* istanbul ignore next */
    function RacingRegionSwitcher(props) {
        var _this = _super.call(this, props) || this;
        /* istanbul ignore next */
        _this.dict = _this.props.dict;
        /* istanbul ignore next */
        _this.state = {
            dataProvider: _this.props.dataProvider,
            selected: 1
        };
        _this.racingStore = RacingStore.getInstance;
        return _this;
    }
    /* istanbul ignore next */
    RacingRegionSwitcher.prototype.handleClick = function (value) {
        this.racingStore.setRegion(value);
    };
    /* istanbul ignore next */
    RacingRegionSwitcher.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "racing-region-selector" }, this.state.dataProvider.regions.map(function (item) {
            return React.createElement(CMP.Region, { key: item.name, label: item.name, selected: _this.racingStore.regionId === item.id ? true : false, handler: function () { return _this.handleClick(item.id); } });
        })));
    };
    RacingRegionSwitcher = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], RacingRegionSwitcher);
    return RacingRegionSwitcher;
}(React.Component));
export { RacingRegionSwitcher };
//# sourceMappingURL=RacingRegionSwitcher.js.map